export default __webpack_public_path__ + "static/media/closecall.00cdb4e5.svg";